module.exports = __webpack_public_path__ + "_assets/img/book03.b17a6c39.svg";